export default __webpack_public_path__ + "static/media/A-Furnished.bcbcd770.png";